// extracted by mini-css-extract-plugin
export default {"headingWrap":"style_headingWrap__sgPJy","heading":"style_heading__uTULX"};